import { NProgress } from '@tanem/react-nprogress';
import { css, cx } from 'linaria';
import { styled } from 'linaria/react';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router';
import { useApolloNetworkStatus } from './NetworkStatusNotifier';
const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
const MemoizedNProgress = React.memo(({
  loading,
  color
}) => {
  return React.createElement(NProgress, {
    isAnimating: loading
  }, ({
    isFinished,
    progress
  }) => React.createElement(Container, {
    progress: progress,
    className: isFinished && 'is-finished',
    color: color
  }));
});

const LoadingBar = function LoadingBar(props) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const status = useApolloNetworkStatus({
    shouldHandleOperation: operation => operation.getContext().useNetworkStatusNotifier !== false
  });
  return mounted && canUseDOM && ReactDOM.createPortal(React.createElement(MemoizedNProgress, {
    loading: status.numPendingMutations + status.numPendingQueries > 0,
    key: props.location.key,
    color: props.color
  }), document.getElementById('root'));
};

const containerStyles = "c1d61tf8";

const Container = function Container({
  progress,
  className,
  color
}) {
  return React.createElement("div", {
    className: cx(containerStyles, className)
  }, React.createElement(Bar, {
    className: "loading-bar",
    style: {
      width: `${progress * 100}%`,
      background: color
    }
  }));
};

const Bar = /*#__PURE__*/styled('div')({
  name: "Bar",
  class: "b1rpry9j"
});
export default withRouter(LoadingBar);

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Loading/LoadingBar.linaria.css");